import {Typography, Input} from 'antd';
import CardItem from './CardItem';
const {Text} = Typography;
const {TextArea} = Input;

const ShopifyNotes = ({notes, updateNotes}) => {
  return (
    <CardItem>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Shopify Notes
        </Text>
      </div>
      <div>
        <TextArea
          value={notes}
          onChange={e => {
            updateNotes(e.target.value);
          }}
          style={{width: '100%', resize: 'none'}}
          placeholder="Add Shopify Notes"
        />
      </div>
    </CardItem>
  );
};

export default ShopifyNotes;
